/**
 * Normalize `meta.pageCopy`-style blocks for `ToolPageCopy` (tools, tasks,
 * agents, explore categories — same taxonomy).
 */
export function normalizeCategoryPageCopy(blocks) {
  if (!Array.isArray(blocks)) return [];
  const supported = new Set([
    'section', 'ordered-list', 'unordered-list', 'cards', 'faq', 'callout',
    'code', 'tip', 'overview', 'quick-links', 'steps', 'divider',
    'progress-bar', 'key-takeaways', 'quiz', 'mock-composer', 'prompt-example', 'try-gab-cta',
  ]);
  const isLegacy = blocks.some((b) => b?.type === 'h2' || b?.type === 'p');
  if (!isLegacy) return blocks.filter((b) => b && supported.has(b.type));

  const out = [];
  for (let i = 0; i < blocks.length; i++) {
    const b = blocks[i];
    if (!b) continue;
    if (supported.has(b.type)) { out.push(b); continue; }
    if (b.type === 'h2') {
      const title = b.text || '';
      const paragraphs = [];
      let j = i + 1;
      while (j < blocks.length && blocks[j]?.type === 'p' && blocks[j]?.text) {
        paragraphs.push(blocks[j].text);
        j += 1;
      }
      out.push({ type: 'section', title, copy: paragraphs.join('\n\n') });
      i = j - 1;
    } else if (b.type === 'p' && b.text) {
      out.push({ type: 'section', copy: b.text });
    }
  }
  return out;
}

export function buildCategoryFaqBlock(faq, title) {
  if (!Array.isArray(faq) || faq.length === 0) return null;
  const items = faq
    .map((row) => {
      if (!row) return null;
      const question = row.question || row.q || row.title;
      const answer = row.answer || row.a || row.copy || row.description;
      if (!question || !answer) return null;
      return { question, answer };
    })
    .filter(Boolean);
  if (items.length === 0) return null;
  return { type: 'faq', title: title || 'Frequently asked questions', items };
}
